import { IconButton } from "@chakra-ui/react"
import { BsThreeDotsVertical } from "react-icons/bs"
import { MenuContent, MenuRoot, MenuTrigger } from "../ui/menu"

import type { SubjectPublic } from "@/client"
import DeleteSubject from "../Subjects/DeleteSubject"
import EditSubject from "../Subjects/EditSubject"

interface SubjectActionsMenuProps {
  subject: SubjectPublic
}

export const SubjectActionsMenu = ({ subject }: SubjectActionsMenuProps) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <IconButton
          variant="ghost"
          color="inherit"
          aria-label="Subject actions"
        >
          <BsThreeDotsVertical />
        </IconButton>
      </MenuTrigger>
      <MenuContent>
        <EditSubject subject={subject} />
        <DeleteSubject subject={subject} />
      </MenuContent>
    </MenuRoot>
  )
}
